module.exports = __webpack_public_path__ + "static/media/ex-peertopeer-img1.748fe074.svg";